// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24lzn","question":"styles_question__2djQf","description":"styles_description__1XtSZ"};